import component from './components/filter';

export default {
  component
};
